<template>
  <div :class="`${classVariableName}-mob-avg-rating-container-main`">
    <div>
      <div :class="`${classVariableName}-heading`">
        Ratings & Reviews
      </div>
      <div :class="`${classVariableName}-sub-heading-1`" v-if="totalRatings === 0" style="margin-top: 8px;">
        Be the first to review this product
      </div>
      <div :class="`${classVariableName}-mob-sub-heading-2`" v-else-if="totalRatings !== 0">
        From {{ totalRatings }} {{ totalRatings === 1 ? " customer" : " customers" }}
      </div>
    </div>
    <div :class="`${classVariableName}-mob-avg-knowmore-container`" v-if="totalRatings !== 0">
      <div :class="`${classVariableName}-mob-avg-rating-content`">
        <div :class="`${classVariableName}-avg-rating-content-stat`">
          <span :class="`${classVariableName}-mob-avg-rating-value`">
            {{averageRating}}
          </span>
          <span :class="`${classVariableName}-mob-avg-rating-max`">
            /{{maximumRating}}
          </span>
        </div>
        <ratingComponent :readOnly="true" :initialRating="averageRating"
          :class="`${classVariableName}-mob-avg-rating-stat-stars`" size="m" />
      </div>

      <div :class="`${classVariableName}-avg-rating-knowmore`" @click="()=>openDetailedStats()">
        View all
        <Arrow direction="right" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { isEmpty, classVariableName, RATING_KEYS } from "../../utils";
import progressBarComponent from "../common/ProgressBar.vue";
import ratingComponent from "../common/StarRating.vue";
import Star from "../common/Star.vue";
import Arrow from "../common/Arrow.vue";
import CertifiedBuyer from "../common/CertifiedBuyer.vue";

export default defineComponent({
  name: "ratingStatsComponent",
  setup() {},
  components: {
    progressBarComponent,
    ratingComponent,
    Star,
    Arrow,
    CertifiedBuyer,
  },
  data() {
    return {
      ratingKeys: RATING_KEYS,
      classVariableName: classVariableName,
      detailedStats: this.viewDetailedStats, // Tracks the view detailed stats
    };
  },
  props: {
    observer: Object,
    averageRating: {
      type: Number,
      default: 0,
    },
    totalRatings: {
      type: Number,
      default: 0,
    },
    verifiedCount: {
      type: Number,
      default: 0,
    },
    ratingStats: {
      type: Object,
      default: {},
    },
    maximumRating: {
      type: Number,
      default: 5,
    },
    viewDetailedStats: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    this.observer?.observe(this.$el);
  },
  methods: {
    isEmpty(val) {
      return isEmpty(val);
    },

    getRatingStats(key) {
      let value =
        isEmpty(this.ratingStats) || isEmpty(this.ratingStats[`${key}`])
          ? 0
          : Math.round((this.ratingStats[`${key}`] / this.totalRatings) * 100);
      return value;
    },

    openDetailedStats() {
      this.detailedStats = true;
      this.$emit("updateViewDetailed", this.detailedStats);
    }
  },
});
</script>
<style lang="scss" scoped>
@import "../../assets/Mob.scss";
</style>
